module.exports = __webpack_public_path__ + "static/img/join_9.01bfb54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_9.jpg
// module id = OpQ5
// module chunks = 1